import { IState } from "./state";
import { ActionTree, Store, ActionContext } from 'vuex';
import * as api from '../api';

type PayloadType = 'initApp' | 'setState' | 'showMore' | 'setQuery' | 'makeSearch' | 'toggleFilter' | 'deselectAllFilters' | 'searchSuggestion' | 'previousPage' | 'nextPage' | 'setActivePage'
export type ActionPayload<ActionData> = {
	type: PayloadType,
	payload: ActionData
}
export interface IToggleFilterPayload {
	id: string,
	value: boolean
}

type ActionHandler<ActionData> = (this: Store<IState>, injectee: ActionContext<IState, IState>, payload: ActionPayload<ActionData>) => any;
type ActionCreator<ActionData> = (data: ActionData) => ActionPayload<ActionData>;


// Action creators
export const initApp: ActionCreator<IState> = (state) => ({
	type: 'initApp',
	payload: state
})
export const previousPage: ActionCreator<undefined> = (undefined) => ({
	type: 'previousPage',
	payload: undefined
})
export const nextPage: ActionCreator<undefined> = (undefined) => ({
	type: 'nextPage',
	payload: undefined
})
export const showMore: ActionCreator<undefined> = (undefined) => ({
	type: 'showMore',
	payload: undefined
})
export const makeSearch: ActionCreator<undefined> = (undefined) => ({
	type: 'makeSearch',
	payload: undefined
})
export const setQuery: ActionCreator<string> = (query) => ({
	type: 'setQuery',
	payload: query
})
export const searchSuggestion: ActionCreator<string> = (payload) => ({
	type: 'searchSuggestion',
	payload: payload
})
export const setActivePage: ActionCreator<number> = value => ({
	type: 'setActivePage',
	payload: value
})

// Action handlers
const searchSuggestionAction: ActionHandler<undefined> = ({ commit, state, dispatch }, { payload }) => {
	commit({
		type: 'setQuery',
		payload: payload
	})
	dispatch({
		type: 'makeSearch',
		payload: undefined
	})

}
const setQueryAction: ActionHandler<string> = ({ commit }, { payload }) => {
	commit({
		type: 'setQuery',
		payload
	})
}
const makeSearchAction: ActionHandler<undefined> = ({ commit, state }, { payload }) => {
	api.search(state.endpoints.searchURL, {
		page: 0,
		query: state.query,
		filter: state.filter
	})
	.then(res => {
		commit({
			type: 'newSearch',
			payload: res
		})
		commit({
			type: 'setSearchedQuery',
			payload: undefined,
		})
		commit({
			type: 'setSuggestion',
			payload: res.suggestion
		})
	})
	
}
const previousPageAction: ActionHandler<undefined> = ({ commit, state }, { payload }) => {
	api.search(state.endpoints.searchURL, {
		page: state.currentPage - 1,
		query: state.query,
		filter: state.filter
	})
	.then(res => {
		commit({
			type: 'decreasePage',
			payload: undefined
		})
	
		commit({
			type: 'setHits',
			payload: res.searchHits
		})
	})
}
const nextPageAction: ActionHandler<undefined> = ({ commit, state }, { payload }) => {
	api.search(state.endpoints.searchURL, {
		page: state.currentPage + 1,
		query: state.query,
		filter: state.filter
	})
	.then(res => {
		commit({
			type: 'increasePage',
			payload: undefined
		})
	
		commit({
			type: 'setHits',
			payload: res.searchHits
		})
	})
}
const showMoreAction: ActionHandler<undefined> = ({ commit, state }, { payload }) => {
	api.search(state.endpoints.searchURL, {
		page: state.currentPage + 1,
		query: state.query,
		filter: state.filter
	})
	.then(res => {
		commit({
			type: 'increasePage',
			payload: undefined
		})
	
		commit({
			type: 'addHits',
			payload: res.searchHits
		})
	})
}
const initAppAction: ActionHandler<IState> = ({ commit }, { payload }) => {
	commit({
		type: 'setState',
		payload
	})
}
const setActivePageAction: ActionHandler<number> = ({ commit, state }, { payload }) => {
	api.search(state.endpoints.searchURL, {
		page: payload,
		query: state.query,
		filter: state.filter
	})
	.then(res => {
		commit({
			type: 'setActivePage',
			payload: payload
		})
		commit({
			type: 'setHits',
			payload: res.searchHits
		})
	})
}
const actions: ActionTree<IState, IState> = {
	initApp: initAppAction,
	previousPage: previousPageAction,
	nextPage: nextPageAction,
	showMore: showMoreAction,
	makeSearch: makeSearchAction,
	setQuery: setQueryAction,
	searchSuggestion: searchSuggestionAction,
	setActivePage: setActivePageAction
}	

export default actions;
